import { render, staticRenderFns } from "./LearningAccommodationStudent.vue?vue&type=template&id=945788d6&scoped=true"
import script from "./LearningAccommodationStudent.vue?vue&type=script&lang=js"
export * from "./LearningAccommodationStudent.vue?vue&type=script&lang=js"
import style0 from "./LearningAccommodationStudent.vue?vue&type=style&index=0&id=945788d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945788d6",
  null
  
)

export default component.exports